// ==== TRAININGS (list/Add-Edit/map/Quick Log/Ace/Training Details) + FEEDING ====
// Split from the original single tempdashboard.js (originally lines 2952-4765).
// Loaded as a plain classic <script defer> alongside the other tempdashboard-*.js files --
// they all share one global scope (like separate parts of one big file), so functions and
// top-level let/const declared in any of these files are visible to all the others, as long
// as the <script> tags stay in the same order every one of these files was split in.

  // ---- TRAININGS: a logbook of tosses -- release point, date/time,
  // distance, which pigeons went, and (via Quick Log Arrivals) which came
  // home and how fast. Speed is calculated from the training's own
  // distance and the elapsed time between release and arrival (both
  // treated as same-day). "Ace Pigeons" (a ranking/leaderboard view) is
  // intentionally left out of this first pass -- a separate feature.
  let trainings = {}; // trainingId -> data
  let editingTrainingId = null;
  let trainingSelectedPigeonIds = new Set();
  let trainingSeasonFilter = 'all'; // 'all' | 'active' | a specific seasonId
  let trainingsPerPage = 10;
  let currentTrainingPage = 1;

  function listenForTrainings() {
    const query = isAdmin ? db.collection('trainings') : db.collection('trainings').where('ownerUid', '==', auth.currentUser.uid);
    query.onSnapshot(snapshot => {
      trainings = {};
      snapshot.forEach(doc => { trainings[doc.id] = doc.data(); });
      document.getElementById('db-nav-trainings-count').textContent = Object.keys(trainings).length || '';
      renderTrainingsList();
      if (document.getElementById('db-panel-home').classList.contains('active')) renderHomeTab();
    }, error => {
      console.error('Trainings listener error:', error);
      showToast('⚠️ Could not load trainings: ' + error.message);
    });
  }

  setupDismissableBanners(['trainings-info-banner'], 'trn-banner-restore-btn', 'fpl-trainings-banners-dismissed');

  // Training status: Planned / Upcoming / Completed. Trainings saved before
  // this field existed fall back to their release time (still in the future =
  // Upcoming, otherwise Completed).
  const TRAINING_STATUS_META = {
    planned: { label: 'Planned' },
    upcoming: { label: 'Upcoming' },
    completed: { label: 'Completed' }
  };
  function trainingStatusOf(t) {
    if (t.status === 'planned' || t.status === 'upcoming' || t.status === 'completed') return t.status;
    return (t.releaseAtMs || 0) > Date.now() ? 'upcoming' : 'completed';
  }
  function trainingNameOf(t) { return t.name || t.releasePoint || 'Training'; }
  function trainingReturnPct(t) {
    const n = (t.participatingPigeonIds || []).length;
    if (!n) return null;
    return Math.round(Object.keys(t.arrivals || {}).length / n * 100);
  }

  let trainingStatusFilter = 'all'; // 'all' | 'planned' | 'upcoming' | 'completed'
  let trainingRangeFrom = ''; // yyyy-mm-dd or ''
  let trainingRangeTo = '';

  // Summary cards, all computed from the real trainings: how many, how many
  // different pigeons have been in one, total distance, and the average
  // return rate (arrived / sent) across completed trainings.
  function renderTrainingsStats() {
    const ids = Object.keys(trainings);
    const pigeonSet = new Set();
    let totalDistance = 0;
    const pcts = [];
    ids.forEach(id => {
      const t = trainings[id];
      totalDistance += (t.distanceKm || 0);
      (t.participatingPigeonIds || []).forEach(pid => pigeonSet.add(pid));
      if (trainingStatusOf(t) === 'completed') {
        const pct = trainingReturnPct(t);
        if (pct !== null) pcts.push(pct);
      }
    });
    const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
    set('trn-stat-total', ids.length);
    set('trn-stat-pigeons', pigeonSet.size);
    set('trn-stat-distance', (Math.round(totalDistance * 10) / 10) + ' km');
    set('trn-stat-return', pcts.length ? Math.round(pcts.reduce((a, b) => a + b, 0) / pcts.length) + '%' : '—');
  }

  // Keeps the season filter's own <option> list in sync with real seasons,
  // same pattern as populatePairSeasonFilter() -- season is an optional
  // filter here, never a visibility gate, so a deleted season just drops
  // out of this list without hiding any training that referenced it.
  function populateTrainingSeasonFilter() {
    const el = document.getElementById('trn-season-filter');
    if (!el) return;
    const prevValue = el.value;
    const seasonIds = Object.keys(seasons).sort((a, b) => (seasons[b].year || 0) - (seasons[a].year || 0));
    el.innerHTML = '<option value="all">All Seasons</option><option value="active">Active Season</option>' +
      seasonIds.map(id => `<option value="${id}">${seasons[id].name} (${seasons[id].year})</option>`).join('');
    if ([...el.options].some(o => o.value === prevValue)) el.value = prevValue;
  }

  function updateTrainingRangeButton() {
    const btn = document.getElementById('trn-range-label');
    if (!btn) return;
    const f = trainingRangeFrom ? fmtDateOnly(new Date(trainingRangeFrom + 'T00:00:00').getTime()) : '';
    const t = trainingRangeTo ? fmtDateOnly(new Date(trainingRangeTo + 'T00:00:00').getTime()) : '';
    btn.textContent = (f || t) ? ((f || '…') + ' – ' + (t || '…')) : 'Select Date Range';
  }

  function renderTrainingsList() {
    renderTrainingsStats();
    populateTrainingSeasonFilter();
    const tbody = document.getElementById('trn-table-body');
    const empty = document.getElementById('trn-empty');
    const tableWrap = document.getElementById('trn-table-wrap');
    const footer = document.getElementById('trn-footer');
    const showingEl = document.getElementById('trn-showing');
    const allIds = Object.keys(trainings);
    const term = ((document.getElementById('trn-search') || {}).value || '').trim().toLowerCase();
    const activeId = activeSeasonId();
    const fromMs = trainingRangeFrom ? new Date(trainingRangeFrom + 'T00:00:00').getTime() : null;
    const toMs = trainingRangeTo ? new Date(trainingRangeTo + 'T23:59:59').getTime() : null;
    let ids = allIds.filter(id => {
      const t = trainings[id];
      if (term && !((t.releasePoint || '').toLowerCase().includes(term) || (t.name || '').toLowerCase().includes(term))) return false;
      if (trainingSeasonFilter === 'active' && t.seasonId !== activeId) return false;
      if (trainingSeasonFilter !== 'all' && trainingSeasonFilter !== 'active' && t.seasonId !== trainingSeasonFilter) return false;
      if (trainingStatusFilter !== 'all' && trainingStatusOf(t) !== trainingStatusFilter) return false;
      if (fromMs !== null && (t.releaseAtMs || 0) < fromMs) return false;
      if (toMs !== null && (t.releaseAtMs || 0) > toMs) return false;
      return true;
    });
    ids.sort((a, b) => (trainings[b].releaseAtMs || 0) - (trainings[a].releaseAtMs || 0));

    document.getElementById('trn-count').textContent = allIds.length ? `(${allIds.length})` : '';
    if (showingEl) showingEl.textContent = '';

    if (ids.length === 0) {
      empty.style.display = 'block';
      tableWrap.style.display = 'none';
      if (footer) footer.style.display = 'none';
      document.getElementById('trn-pagination').innerHTML = '';
      document.getElementById('trn-empty-title').textContent = allIds.length === 0 ? 'No trainings found.' : 'No trainings match your search.';
      document.getElementById('trn-empty-text').textContent = allIds.length === 0
        ? 'Click "+ Add Training" above to log your first toss.'
        : 'Try a different search term or filter.';
      return;
    }
    empty.style.display = 'none';
    tableWrap.style.display = '';
    if (footer) footer.style.display = '';

    const totalPages = trainingsPerPage === Infinity ? 1 : Math.max(1, Math.ceil(ids.length / trainingsPerPage));
    if (currentTrainingPage > totalPages) currentTrainingPage = totalPages;
    const startIdx = trainingsPerPage === Infinity ? 0 : (currentTrainingPage - 1) * trainingsPerPage;
    const pageIds = trainingsPerPage === Infinity ? ids : ids.slice(startIdx, startIdx + trainingsPerPage);

    renderTrainingsPagination(totalPages);
    if (showingEl) {
      showingEl.textContent = 'Showing ' + (startIdx + 1) + ' to ' + (startIdx + pageIds.length) + ' of ' + ids.length +
        ' training' + (ids.length !== 1 ? 's' : '');
    }
    tbody.innerHTML = '';
    pageIds.forEach((id, i) => {
      const t = trainings[id];
      const arrivals = t.arrivals || {};
      const pigeonCount = (t.participatingPigeonIds || []).length;
      const status = trainingStatusOf(t);
      const pct = trainingReturnPct(t);
      const released = (t.releaseAtMs || 0) <= Date.now();
      const returnStr = released && pct !== null ? pct + '%' : '—';
      const speeds = Object.values(arrivals).map(a => a.speedKmH).filter(Boolean);
      const bestSpeed = speeds.length ? Math.max(...speeds) : null;
      const dateStr = t.releaseAtMs ? fmtDateOnly(t.releaseAtMs) : '—';
      const season = t.seasonId ? seasons[t.seasonId] : null;
      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td class="trn-col-num">${startIdx + i + 1}</td>
        <td class="trn-col-name">
          <div class="trn-mob-head">
            <span class="trn-mob-icon trn-mob-icon--${status}"><i class="fa-solid fa-flag"></i></span>
            <div class="szn-name">${trainingNameOf(t)}</div>
          </div>
          ${season ? `<div class="trn-season-line">${season.name} (${season.year})</div>` : ''}
          <div class="trn-mob">
            <div class="trn-mob-date"><i class="fa-regular fa-calendar"></i> ${dateStr}</div>
            <div class="trn-mob-loc"><i class="fa-solid fa-location-dot"></i> ${t.releasePoint || '—'} <span class="trn-mob-dot">•</span> ${t.distanceKm || 0} km</div>
            <div class="trn-mob-row"><span><i class="fa-solid fa-dove"></i> ${pigeonCount} pigeon${pigeonCount === 1 ? '' : 's'}</span><span>${released && pct !== null ? '<i class="fa-solid fa-chart-simple"></i> ' + pct + '%' : '—'}</span></div>
          </div>
        </td>
        <td class="trn-col-date">${dateStr}</td>
        <td class="trn-col-loc">${t.releasePoint || '—'}</td>
        <td class="trn-col-dist">${t.distanceKm || 0} km</td>
        <td class="trn-col-pigeons">${pigeonCount}</td>
        <td class="trn-col-return"><span class="trn-return-pct">${returnStr}</span>${bestSpeed ? `<span class="trn-return-speed">${Math.round(speedToMPerMin(bestSpeed))} m/min best</span>` : ''}</td>
        <td class="trn-col-status"><span class="pgn-badge trn-badge--${status}">${TRAINING_STATUS_META[status].label}</span></td>
        <td class="trn-col-actions">
          <div class="szn-actions">
            <button type="button" class="szn-btn trn-view-btn"><i class="fa-solid fa-eye"></i> View</button>
            <button type="button" class="szn-btn trn-edit-btn"><i class="fa-solid fa-pen"></i> Edit</button>
            <button type="button" class="trn-mob-chevron" aria-label="View training"><i class="fa-solid fa-chevron-right"></i></button>
            <div class="szn-kebab-wrap">
              <button type="button" class="ltc-kebab-btn pgn-kebab trn-kebab-btn" aria-label="More actions"><i class="fa-solid fa-ellipsis-vertical"></i></button>
              <div class="ltc-kebab-menu">
                <div class="ltc-kebab-menu-item trn-mob-menu-item trn-mob-view-item"><i class="fa-solid fa-eye"></i> View Training</div>
                <div class="ltc-kebab-menu-item trn-mob-menu-item trn-mob-edit-item"><i class="fa-solid fa-pen"></i> Edit Training</div>
                <div class="ltc-kebab-menu-item trn-mob-menu-item trn-mob-logarrivals-item"><i class="fa-solid fa-bolt"></i> Log Arrivals</div>
                <div class="ltc-kebab-menu-divider trn-mob-menu-item"></div>
                <div class="ltc-kebab-menu-item trn-copy-item"><i class="fa-solid fa-copy"></i> Copy Training</div>
                <div class="ltc-kebab-menu-divider"></div>
                <div class="ltc-kebab-menu-item danger trn-delete-item"><i class="fa-solid fa-trash"></i> Delete</div>
              </div>
            </div>
          </div>
        </td>
      `;
      const kebabBtn = tr.querySelector('.trn-kebab-btn');
      const kebabMenu = tr.querySelector('.ltc-kebab-menu');
      tr.onclick = (e) => {
        if (e.target.closest('.szn-actions')) return;
        openTrainingDetailModal(id);
      };
      tr.querySelector('.trn-view-btn').onclick = (e) => { e.stopPropagation(); openTrainingDetailModal(id); };
      tr.querySelector('.trn-edit-btn').onclick = (e) => { e.stopPropagation(); openEditTrainingModal(id, t); };
      tr.querySelector('.trn-mob-chevron').onclick = (e) => { e.stopPropagation(); openTrainingDetailModal(id); };
      // Mobile-only kebab extras (hidden on desktop via CSS) -- the visible
      // View/Edit buttons and this row's own tap-to-open already cover
      // desktop, but the mobile card hides those buttons down to just the
      // status badge + chevron, so the kebab needs to offer them instead.
      tr.querySelector('.trn-mob-view-item').onclick = (e) => { e.stopPropagation(); kebabMenu.classList.remove('open'); openTrainingDetailModal(id); };
      tr.querySelector('.trn-mob-edit-item').onclick = (e) => { e.stopPropagation(); kebabMenu.classList.remove('open'); openEditTrainingModal(id, t); };
      tr.querySelector('.trn-mob-logarrivals-item').onclick = (e) => { e.stopPropagation(); kebabMenu.classList.remove('open'); openQuickLogPage(id); };
      kebabBtn.onclick = (e) => {
        e.stopPropagation();
        const wasOpen = kebabMenu.classList.contains('open');
        document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
        if (!wasOpen) { kebabMenu.classList.add('open'); keepKebabMenuInView(kebabMenu); }
      };
      tr.querySelector('.trn-copy-item').onclick = async (e) => {
        e.stopPropagation();
        kebabMenu.classList.remove('open');
        try {
          const data = {
            releasePoint: t.name ? t.releasePoint : t.releasePoint + ' (copy)', releaseAtMs: t.releaseAtMs, distanceKm: t.distanceKm, seasonId: t.seasonId || null,
            notes: t.notes || '', participatingPigeonIds: t.participatingPigeonIds || [],
            orgId: currentOrg.slug, ownerUid: auth.currentUser.uid
          };
          if (t.name) data.name = t.name + ' (copy)';
          if (t.status) data.status = t.status;
          if (typeof t.releaseLat === 'number' && typeof t.releaseLng === 'number') { data.releaseLat = t.releaseLat; data.releaseLng = t.releaseLng; }
          const ref = await db.collection('trainings').add({ ...data, arrivals: {}, createdAt: firebase.firestore.FieldValue.serverTimestamp() });
          trainings[ref.id] = { ...data, arrivals: {} };
          renderTrainingsList();
          showToast('✅ Copied "' + trainingNameOf(t) + '"');
        } catch (e2) { showToast('Could not copy: ' + e2.message); }
      };
      tr.querySelector('.trn-delete-item').onclick = async (e) => {
        e.stopPropagation();
        kebabMenu.classList.remove('open');
        if (!(await showConfirmModal('Delete this training? This cannot be undone.', 'Delete training?'))) return;
        try {
          await db.collection('trainings').doc(id).delete();
          delete trainings[id];
          renderTrainingsList();
          showToast('🗑️ Training deleted');
        } catch (e2) { showToast('Could not delete: ' + e2.message); }
      };
      tbody.appendChild(tr);
    });
  }

  function renderTrainingsPagination(totalPages) {
    const el = document.getElementById('trn-pagination');
    if (!el) return;
    el.innerHTML = '';
    if (totalPages <= 1) return;
    const prevBtn = document.createElement('button');
    prevBtn.textContent = '← Prev';
    prevBtn.disabled = currentTrainingPage === 1;
    prevBtn.onclick = () => { currentTrainingPage--; renderTrainingsList(); };
    el.appendChild(prevBtn);
    for (let i = 1; i <= totalPages; i++) {
      const pageBtn = document.createElement('button');
      pageBtn.textContent = i;
      if (i === currentTrainingPage) pageBtn.className = 'active';
      pageBtn.onclick = () => { currentTrainingPage = i; renderTrainingsList(); };
      el.appendChild(pageBtn);
    }
    const nextBtn = document.createElement('button');
    nextBtn.textContent = 'Next →';
    nextBtn.disabled = currentTrainingPage === totalPages;
    nextBtn.onclick = () => { currentTrainingPage++; renderTrainingsList(); };
    el.appendChild(nextBtn);
  }

  // Toolbar: search, season, status, date range, rows per page.
  (function wireTrainingsToolbar() {
    const search = document.getElementById('trn-search');
    if (search) search.oninput = () => { currentTrainingPage = 1; renderTrainingsList(); };
    const seasonSel = document.getElementById('trn-season-filter');
    if (seasonSel) seasonSel.onchange = (e) => { trainingSeasonFilter = e.target.value; currentTrainingPage = 1; renderTrainingsList(); };
    const statusSel = document.getElementById('trn-status-filter');
    if (statusSel) statusSel.onchange = (e) => { trainingStatusFilter = e.target.value; currentTrainingPage = 1; renderTrainingsList(); };
    const perPage = document.getElementById('trn-per-page');
    if (perPage) perPage.onchange = (e) => {
      trainingsPerPage = e.target.value === 'all' ? Infinity : parseInt(e.target.value, 10);
      currentTrainingPage = 1;
      renderTrainingsList();
    };
    // Date range popover
    const rangeWrap = document.getElementById('trn-range');
    const rangeBtn = document.getElementById('trn-range-btn');
    const rangePop = document.getElementById('trn-range-pop');
    if (rangeBtn && rangePop) {
      rangeBtn.onclick = (e) => {
        e.stopPropagation();
        document.getElementById('trn-range-from').value = trainingRangeFrom;
        document.getElementById('trn-range-to').value = trainingRangeTo;
        rangePop.classList.toggle('open');
      };
      rangePop.onclick = (e) => e.stopPropagation();
      document.getElementById('trn-range-apply').onclick = () => {
        trainingRangeFrom = document.getElementById('trn-range-from').value;
        trainingRangeTo = document.getElementById('trn-range-to').value;
        if (trainingRangeFrom && trainingRangeTo && trainingRangeTo < trainingRangeFrom) {
          const tmp = trainingRangeFrom; trainingRangeFrom = trainingRangeTo; trainingRangeTo = tmp;
        }
        rangePop.classList.remove('open');
        updateTrainingRangeButton();
        currentTrainingPage = 1;
        renderTrainingsList();
      };
      document.getElementById('trn-range-clear').onclick = () => {
        trainingRangeFrom = ''; trainingRangeTo = '';
        rangePop.classList.remove('open');
        updateTrainingRangeButton();
        currentTrainingPage = 1;
        renderTrainingsList();
      };
      document.addEventListener('click', (e) => { if (rangeWrap && !rangeWrap.contains(e.target)) rangePop.classList.remove('open'); });
    }
  })();

  // ---- Add/Edit Training modal: pigeon picker (searchable cards, with
  // Select All and the cock/hen tag shortcuts) shares one Set of selected
  // ids across re-renders so filtering the search doesn't lose picks.
  function pigeonAvatarHtml(p) {
    const initials = ((p && p.name) || '?').trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?';
    const avatarColor = (p && p.markerColor) || '#2f6fed';
    return `<span class="pigeon-avatar" style="background:${avatarColor};color:#fff;"><span>${initials}</span>${p && p.photoURL ? `<img src="${p.photoURL}" class="pigeon-avatar-img" onerror="this.style.display='none'">` : ''}</span>`;
  }

  function populateTrainingPigeonList(filterTerm) {
    const container = document.getElementById('trn-pigeon-list');
    const ownPigeons = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    const term = (filterTerm || '').toLowerCase();
    const filtered = !term ? ownPigeons : ownPigeons.filter(d =>
      (d.p.name || '').toLowerCase().includes(term) || (d.p.ringNumber || '').toLowerCase().includes(term)
    );
    container.innerHTML = filtered.map(d => {
      const checked = trainingSelectedPigeonIds.has(d.id);
      return `
      <label class="trn-pcard${checked ? ' selected' : ''}">
        <input type="checkbox" class="trn-pigeon-checkbox" data-id="${d.id}" ${checked ? 'checked' : ''}>
        ${pigeonAvatarHtml(d.p)}
        <span class="trn-pcard-text"><b>${d.p.name}</b><span>${d.p.ringNumber || 'No ring number'}</span></span>
        <span class="trn-pcard-sex">${d.p.sex === 'cock' || d.p.sex === 'hen' ? sexIconHtml(d.p.sex) : ''}</span>
      </label>`;
    }).join('') || '<div class="trn-pick-empty">No pigeons match.</div>';
    container.querySelectorAll('.trn-pigeon-checkbox').forEach(cb => {
      cb.onchange = () => {
        if (cb.checked) trainingSelectedPigeonIds.add(cb.dataset.id);
        else trainingSelectedPigeonIds.delete(cb.dataset.id);
        cb.closest('.trn-pcard').classList.toggle('selected', cb.checked);
        updateTrainingSelectedCount();
      };
    });
  }
  function updateTrainingSelectedCount() {
    const n = trainingSelectedPigeonIds.size;
    document.getElementById('trn-selected-count').textContent = n + ' pigeon' + (n === 1 ? '' : 's') + ' selected';
    const own = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    const allCb = document.getElementById('trn-select-all-cb');
    if (allCb) allCb.checked = own.length > 0 && own.every(d => trainingSelectedPigeonIds.has(d.id));
    updateTrainingSummary();
  }
  const trnPigeonSearchEl = document.getElementById('trn-pigeon-search');
  if (trnPigeonSearchEl) trnPigeonSearchEl.oninput = (e) => populateTrainingPigeonList(e.target.value);
  const trnSelectAllCb = document.getElementById('trn-select-all-cb');
  if (trnSelectAllCb) trnSelectAllCb.onchange = () => {
    const own = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    if (trnSelectAllCb.checked) own.forEach(d => trainingSelectedPigeonIds.add(d.id));
    else trainingSelectedPigeonIds.clear();
    document.querySelectorAll('.trn-tag-btn').forEach(b => b.classList.remove('selected'));
    populateTrainingPigeonList(document.getElementById('trn-pigeon-search').value);
    updateTrainingSelectedCount();
  };
  document.querySelectorAll('.trn-tag-btn').forEach(btn => {
    btn.onclick = () => {
      btn.classList.toggle('selected');
      const tag = btn.dataset.tag;
      const matching = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug && d.p.sex === tag);
      if (btn.classList.contains('selected')) matching.forEach(d => trainingSelectedPigeonIds.add(d.id));
      else matching.forEach(d => trainingSelectedPigeonIds.delete(d.id));
      populateTrainingPigeonList(document.getElementById('trn-pigeon-search').value);
      updateTrainingSelectedCount();
    };
  });
  // Season here is a plain optional label -- unlike Breeding Pairs, it's
  // never required and a deleted season just leaves the training's own
  // season blank next render, no other effect.
  function populateTrainingSeasonSelect() {
    const el = document.getElementById('trn-season');
    if (!el) return;
    const seasonIds = Object.keys(seasons).sort((a, b) => (seasons[b].year || 0) - (seasons[a].year || 0));
    el.innerHTML = '<option value="">No season</option>' +
      seasonIds.map(id => `<option value="${id}">${seasons[id].name} (${seasons[id].year})</option>`).join('');
  }

  // Live "Summary" card on the right of the dialog -- mirrors whatever is currently entered.
  function updateTrainingSummary() {
    const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
    const dateVal = document.getElementById('trn-release-date').value;
    const dist = document.getElementById('trn-distance').value;
    const status = document.getElementById('trn-status-select').value;
    set('trn-sum-name', document.getElementById('trn-name').value.trim() || '—');
    set('trn-sum-date', dateVal ? fmtDateOnly(new Date(dateVal + 'T00:00:00').getTime()) : '—');
    set('trn-sum-location', document.getElementById('trn-release-point').value.trim() || '—');
    set('trn-sum-distance', dist ? dist + ' km' : '—');
    set('trn-sum-time', document.getElementById('trn-release-time').value || '—');
    set('trn-sum-pigeons', trainingSelectedPigeonIds.size);
    const badge = document.getElementById('trn-sum-status');
    if (badge) { badge.className = 'pgn-badge trn-badge--' + status; badge.textContent = TRAINING_STATUS_META[status].label; }
    updateTrnMapSelected();
  }
  ['trn-name', 'trn-release-date', 'trn-release-point', 'trn-distance', 'trn-release-time', 'trn-status-select'].forEach(id => {
    const el = document.getElementById(id);
    if (el) { el.addEventListener('input', updateTrainingSummary); el.addEventListener('change', updateTrainingSummary); }
  });

  // ---- Optional release-location map (same Leaflet/Nominatim helpers the
  // Group Tracking release point already uses): search a place or click the
  // map to drop a flag; the coordinates are saved with the training.
  let trnMap = null;
  let trnMarker = null;
  let trnPoint = null; // {lat, lng} or null
  let trnMapReadyPromise = null;
  let trnLocationAutoFilled = true;
  const TRN_MAP_DEFAULT_VIEW = [54.5, -3, 5];

  function ensureTrnMap() {
    if (trnMapReadyPromise) return trnMapReadyPromise;
    trnMapReadyPromise = ensureLeafletLoaded().then(() => {
      trnMap = L.map('trn-map', { attributionControl: false }).setView([TRN_MAP_DEFAULT_VIEW[0], TRN_MAP_DEFAULT_VIEW[1]], TRN_MAP_DEFAULT_VIEW[2]);
      NT_TILE_LAYERS.detailed().addTo(trnMap);
      trnMap.on('click', (e) => setTrnPoint(e.latlng.lat, e.latlng.lng));
    }).catch(err => { console.error('Training map failed to load:', err); });
    return trnMapReadyPromise;
  }
  function refreshTrnMapView() {
    if (!trnMap) return;
    trnMap.invalidateSize();
    if (trnPoint) trnMap.setView([trnPoint.lat, trnPoint.lng], Math.max(trnMap.getZoom(), 12));
    else trnMap.setView([TRN_MAP_DEFAULT_VIEW[0], TRN_MAP_DEFAULT_VIEW[1]], TRN_MAP_DEFAULT_VIEW[2]);
  }
  function updateTrnMapSelected() {
    const nameEl = document.getElementById('trn-map-selected-name');
    const coordEl = document.getElementById('trn-map-selected-coords');
    if (!nameEl || !coordEl) return;
    if (trnPoint) {
      nameEl.textContent = document.getElementById('trn-release-point').value.trim() || 'Selected location';
      coordEl.textContent = 'Lat: ' + trnPoint.lat.toFixed(4) + ', Lng: ' + trnPoint.lng.toFixed(4);
    } else {
      nameEl.textContent = 'No location selected';
      coordEl.textContent = 'Search for a place or click the map to set the release point.';
    }
  }
  function maybeAutoFillTrnLocation(lat, lng) {
    if (!trnLocationAutoFilled) return;
    resolvePointAddress({ lat, lng }, addr => {
      if (!trnLocationAutoFilled) return;
      if (!trnPoint || trnPoint.lat !== lat || trnPoint.lng !== lng) return;
      document.getElementById('trn-release-point').value = addr.split(',').slice(0, 2).join(',').trim();
      updateTrainingSummary();
    });
  }
  function setTrnPoint(lat, lng, skipZoom, skipAutoName) {
    trnPoint = { lat, lng };
    if (trnMap) {
      if (!trnMarker) {
        trnMarker = L.marker([lat, lng], {
          draggable: true,
          icon: L.divIcon({ className: '', html: '<i class="fa-solid fa-location-dot" style="color:#e53935;font-size:28px;filter:drop-shadow(0 1px 2px rgba(0,0,0,0.4));"></i>', iconSize: [22, 28], iconAnchor: [11, 27] })
        }).addTo(trnMap);
        trnMarker.on('drag', (e) => { const ll = e.target.getLatLng(); trnPoint = { lat: ll.lat, lng: ll.lng }; updateTrnMapSelected(); });
        trnMarker.on('dragend', (e) => { const ll = e.target.getLatLng(); maybeAutoFillTrnLocation(ll.lat, ll.lng); });
      } else {
        trnMarker.setLatLng([lat, lng]);
      }
      if (!skipZoom) trnMap.setView([lat, lng], 13);
    }
    updateTrnMapSelected();
    if (!skipAutoName) maybeAutoFillTrnLocation(lat, lng);
  }
  function clearTrnPoint() {
    trnPoint = null;
    if (trnMarker && trnMap) { trnMap.removeLayer(trnMarker); }
    trnMarker = null;
    updateTrnMapSelected();
  }
  document.getElementById('trn-release-point').addEventListener('input', () => { trnLocationAutoFilled = false; });

  function hideTrnSuggestions() {
    const el = document.getElementById('trn-map-suggestions');
    el.classList.remove('open');
    el.innerHTML = '';
  }
  async function showTrnSuggestions(q) {
    if (!q) return;
    let results;
    try {
      results = await nominatimSearch(q);
    } catch (err) {
      showToast('Search failed: ' + err.message);
      return;
    }
    if (document.getElementById('trn-map-search').value.trim() !== q) return;
    if (!results.length) { hideTrnSuggestions(); showToast('No matching place found'); return; }
    const suggestEl = document.getElementById('trn-map-suggestions');
    suggestEl.innerHTML = results.map((r, i) => `<div class="grp-release-suggestion" data-idx="${i}">${r.display_name}</div>`).join('');
    suggestEl.classList.add('open');
    suggestEl.querySelectorAll('.grp-release-suggestion').forEach((el, i) => {
      el.onclick = () => {
        const r = results[i];
        document.getElementById('trn-map-search').value = r.display_name;
        hideTrnSuggestions();
        ensureTrnMap().then(() => {
          setTrnPoint(parseFloat(r.lat), parseFloat(r.lon), true, true);
          if (trnMap) {
            if (r.boundingbox && r.boundingbox.length === 4) {
              const [south, north, west, east] = r.boundingbox.map(parseFloat);
              trnMap.fitBounds([[south, west], [north, east]], { maxZoom: 15, padding: [20, 20] });
            } else {
              trnMap.setView([parseFloat(r.lat), parseFloat(r.lon)], 13);
            }
          }
          document.getElementById('trn-release-point').value = r.display_name.split(',').slice(0, 2).join(',').trim();
          updateTrainingSummary();
        });
      };
    });
  }
  let trnSuggestTimer = null;
  (function wireTrnMapSearch() {
    const input = document.getElementById('trn-map-search');
    if (!input) return;
    input.addEventListener('input', (e) => {
      clearTimeout(trnSuggestTimer);
      const q = e.target.value.trim();
      if (q.length < 3) { hideTrnSuggestions(); return; }
      trnSuggestTimer = setTimeout(() => showTrnSuggestions(q), 400);
    });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); clearTimeout(trnSuggestTimer); showTrnSuggestions(input.value.trim()); }
      if (e.key === 'Escape') hideTrnSuggestions();
    });
    document.addEventListener('click', (e) => { if (!input.parentElement.contains(e.target)) hideTrnSuggestions(); });
  })();

  function fillTrainingModalCommon() {
    populateTrainingSeasonSelect();
    document.querySelectorAll('.trn-tag-btn').forEach(b => b.classList.remove('selected'));
    document.getElementById('trn-pigeon-search').value = '';
    document.getElementById('trn-map-search').value = '';
    hideTrnSuggestions();
    document.getElementById('trn-status-msg').textContent = '';
    populateTrainingPigeonList('');
  }
  function openTrainingModalShell(point) {
    document.getElementById('db-training-modal').classList.add('open');
    ensureTrnMap().then(() => {
      setTimeout(() => {
        refreshTrnMapView();
        if (point) setTrnPoint(point.lat, point.lng, false, true); else clearTrnPoint();
        refreshTrnMapView();
      }, 60);
    });
  }

  function openAddTrainingModal() {
    editingTrainingId = null;
    trainingSelectedPigeonIds = new Set();
    document.getElementById('db-training-modal-title').textContent = 'Add Training';
    document.getElementById('db-training-modal-mback-label').textContent = 'Add Training';
    document.getElementById('db-training-modal-subtitle').textContent = 'Create a new training session for your pigeons.';
    document.getElementById('trn-save-label').textContent = 'Save Training';
    document.getElementById('trn-name').value = '';
    document.getElementById('trn-release-point').value = '';
    trnLocationAutoFilled = true;
    const now = new Date();
    document.getElementById('trn-release-date').value = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
    document.getElementById('trn-release-time').value = '';
    document.getElementById('trn-distance').value = '';
    document.getElementById('trn-status-select').value = 'planned';
    document.getElementById('trn-notes').value = '';
    fillTrainingModalCommon();
    document.getElementById('trn-season').value = activeSeasonId() || '';
    updateTrainingSelectedCount();
    clearTrnPoint();
    openTrainingModalShell(null);
  }
  function openEditTrainingModal(id, t) {
    editingTrainingId = id;
    trainingSelectedPigeonIds = new Set(t.participatingPigeonIds || []);
    document.getElementById('db-training-modal-title').textContent = 'Edit Training';
    document.getElementById('db-training-modal-mback-label').textContent = 'Edit Training';
    document.getElementById('db-training-modal-subtitle').textContent = 'Update the details of this training session.';
    document.getElementById('trn-save-label').textContent = 'Save Changes';
    document.getElementById('trn-name').value = t.name || t.releasePoint || '';
    document.getElementById('trn-release-point').value = t.releasePoint || '';
    trnLocationAutoFilled = false; // an existing name is the user's own -- never overwrite it from the map
    const d = t.releaseAtMs ? new Date(t.releaseAtMs) : new Date();
    document.getElementById('trn-release-date').value = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    document.getElementById('trn-release-time').value = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    document.getElementById('trn-distance').value = t.distanceKm || '';
    document.getElementById('trn-status-select').value = trainingStatusOf(t);
    document.getElementById('trn-notes').value = t.notes || '';
    fillTrainingModalCommon();
    document.getElementById('trn-season').value = t.seasonId || '';
    updateTrainingSelectedCount();
    const hasPoint = typeof t.releaseLat === 'number' && typeof t.releaseLng === 'number';
    if (!hasPoint) clearTrnPoint();
    openTrainingModalShell(hasPoint ? { lat: t.releaseLat, lng: t.releaseLng } : null);
  }
  const trnAddBtn = document.getElementById('trn-add-btn');
  if (trnAddBtn) trnAddBtn.onclick = openAddTrainingModal;
  const trnCancelBtn = document.getElementById('trn-cancel');
  if (trnCancelBtn) trnCancelBtn.onclick = () => document.getElementById('db-training-modal').classList.remove('open');
  const trnSaveBtn = document.getElementById('trn-save');
  if (trnSaveBtn) trnSaveBtn.onclick = async () => {
    const statusEl = document.getElementById('trn-status-msg');
    try {
      const name = document.getElementById('trn-name').value.trim();
      const releasePoint = document.getElementById('trn-release-point').value.trim();
      const releaseDate = document.getElementById('trn-release-date').value;
      const releaseTime = document.getElementById('trn-release-time').value;
      const distanceKm = parseFloat(document.getElementById('trn-distance').value) || 0;
      const seasonId = document.getElementById('trn-season').value || null;
      const status = document.getElementById('trn-status-select').value;
      const notes = document.getElementById('trn-notes').value.trim();
      if (!name || !releasePoint || !releaseDate || !releaseTime) {
        statusEl.textContent = 'Training name, date, location and release time are required.';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Training name, date, location and release time are required');
        return;
      }
      if (!(distanceKm > 0)) {
        statusEl.textContent = 'Enter the distance in km.';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Enter the distance in km');
        return;
      }
      if (trainingSelectedPigeonIds.size === 0) {
        statusEl.textContent = 'Select at least one participating pigeon.';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Select at least one pigeon');
        return;
      }
      const releaseAtMs = new Date(releaseDate + 'T' + releaseTime).getTime();
      // A Completed training logs a toss that already happened -- a future
      // release time can never have real arrivals yet, so that combination is
      // rejected. Planned / Upcoming trainings are scheduled ahead of time, so
      // a future date is fine for those.
      if (status === 'completed' && releaseAtMs > Date.now()) {
        statusEl.textContent = 'A completed training can\'t have a release date/time in the future.';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ A completed training can\'t be in the future');
        return;
      }
      statusEl.textContent = 'Saving...';
      statusEl.style.color = '#6b7a87';
      const data = {
        name, releasePoint, releaseAtMs, distanceKm, seasonId, notes, status,
        releaseLat: trnPoint ? trnPoint.lat : null,
        releaseLng: trnPoint ? trnPoint.lng : null,
        participatingPigeonIds: Array.from(trainingSelectedPigeonIds),
        orgId: currentOrg.slug, ownerUid: auth.currentUser.uid
      };
      if (editingTrainingId) {
        await db.collection('trainings').doc(editingTrainingId).update(data);
        trainings[editingTrainingId] = { ...trainings[editingTrainingId], ...data };
      } else {
        const ref = await db.collection('trainings').add({ ...data, arrivals: {}, createdAt: firebase.firestore.FieldValue.serverTimestamp() });
        trainings[ref.id] = { ...data, arrivals: {} };
      }
      renderTrainingsList();
      showToast(editingTrainingId ? '✅ Training updated' : '✅ Training saved');
      document.getElementById('db-training-modal').classList.remove('open');
    } catch (e) {
      console.error('Training save failed:', e);
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
      showToast('❌ Could not save training: ' + e.message);
    }
  };

  // ---- FEEDING: full page rebuild matching the new mockups (2026-09-22) --
  // same hero/stats/toolbar/table/pagination pattern as Trainings, plus a
  // Feed Types sub-entity (name/description/photo, created inline via
  // "+ Add Feed Type" inside Add/Edit Feeding) and two read-only summary
  // cards computed live from the real feedings: Feed Type Usage (last 30
  // days) and Feeding Schedule (each time-of-day bucket's most recent real
  // feeding -- nothing fabricated, same principle as Ace Pigeons/Training
  // Details only ever using real data).
  //
  // Two deliberate simplifications, flagged here rather than silently:
  // (1) "Select Group" has no dedicated group entity anywhere in this app
  // (Group Tracking's "groups" are GPS-tracker groups, unrelated) -- it
  // reuses the old free-text loftGroup concept (a simple name typed in)
  // instead of a whole new pigeon-groups CRUD feature that wasn't asked
  // for. (2) Feed Type Usage sums raw quantity numbers across a feeding's
  // chosen unit (kg/g/lbs/cups) without converting between units -- fine
  // for the common case of one consistent unit, but mixing units skews the
  // percentages; a real unit-conversion table is future scope.
  //
  // Desktop only for this pass, per the brief -- mobile Feeding is a later,
  // separate pass, same as every other page.
  let feedTypes = {}; // id -> {name, description, photoURL, colorHex}
  let feedings = {}; // id -> data
  let feedingsPerPage = 10;
  let currentFeedingPage = 1;
  let editingFeedingId = null;
  let feedingSelectedFeedTypeId = null;
  let feedingPigeonScope = 'all';
  let feedingSelectedPigeonIds = new Set();

  function listenForFeedTypes() {
    const query = isAdmin ? db.collection('feedTypes') : db.collection('feedTypes').where('ownerUid', '==', auth.currentUser.uid);
    query.onSnapshot(snapshot => {
      feedTypes = {};
      snapshot.forEach(doc => { feedTypes[doc.id] = doc.data(); });
      populateFeedTypeFilter();
      renderFeedTypeCards();
      renderFeedingList();
    }, error => {
      console.error('Feed types listener error:', error);
      showToast('⚠️ Could not load feed types: ' + error.message);
    });
  }

  function listenForFeedings() {
    const query = isAdmin ? db.collection('feedings') : db.collection('feedings').where('ownerUid', '==', auth.currentUser.uid);
    query.onSnapshot(snapshot => {
      feedings = {};
      snapshot.forEach(doc => { feedings[doc.id] = doc.data(); });
      document.getElementById('db-nav-feeding-count').textContent = Object.keys(feedings).length || '';
      renderFeedingList();
    }, error => {
      console.error('Feedings listener error:', error);
      showToast('⚠️ Could not load feeding entries: ' + error.message);
    });
  }

  setupDismissableBanners(['feeding-info-banner'], 'feed-banner-restore-btn', 'fpl-feeding-banners-dismissed');

  // Every new feed type gets the first palette color not already used by
  // one of this org's own feed types -- same approach pickAutoMarkerColor
  // already uses for pigeons, so the dot/avatar colors stay distinguishable
  // without asking the user to pick one.
  function pickAutoFeedTypeColor() {
    const used = new Set(Object.values(feedTypes).filter(f => f.orgId === currentOrg.slug).map(f => f.colorHex).filter(Boolean));
    const unused = MARKER_COLOR_PALETTE.find(c => !used.has(c.hex));
    return (unused || MARKER_COLOR_PALETTE[Math.floor(Math.random() * MARKER_COLOR_PALETTE.length)]).hex;
  }

  function feedTypeAvatarHtml(ft, extraClass) {
    const color = (ft && ft.colorHex) || '#8a97a3';
    const cls = 'feedtype-avatar' + (extraClass ? ' ' + extraClass : '');
    return `<span class="${cls}" style="background:${color};">` +
      (ft && ft.photoURL ? `<img src="${ft.photoURL}" alt="" onerror="this.style.display='none'">` : '<i class="fa-solid fa-wheat-awn"></i>') +
      `</span>`;
  }

  function resolveFeedingPigeonIds(f) {
    if (f.pigeonScope === 'select') return f.pigeonIds || [];
    if (f.pigeonScope === 'group') return [];
    return allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug).map(d => d.id);
  }
  function resolveFeedingPigeonCount(f) {
    if (f.pigeonScope === 'select') return (f.pigeonIds || []).length;
    if (f.pigeonScope === 'group') return null;
    return allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug).length;
  }

  function renderFeedingStats() {
    const ids = Object.keys(feedings);
    const pigeonSet = new Set();
    ids.forEach(id => resolveFeedingPigeonIds(feedings[id]).forEach(pid => pigeonSet.add(pid)));
    const typesUsed = new Set(ids.map(id => feedings[id].feedTypeId).filter(Boolean)).size;
    const weekAgo = Date.now() - 7 * 86400000;
    const thisWeek = ids.filter(id => (feedings[id].fedAtMs || 0) >= weekAgo).length;
    document.getElementById('feed-stat-total').textContent = ids.length;
    document.getElementById('feed-stat-pigeons').textContent = pigeonSet.size;
    document.getElementById('feed-stat-types').textContent = typesUsed;
    document.getElementById('feed-stat-week').textContent = thisWeek;
  }

  function feedingDateMatchesFilter(fedAtMs, filter) {
    if (filter === 'all') return true;
    if (!fedAtMs) return false;
    const now = Date.now();
    switch (filter) {
      case 'today': { const t = new Date(); t.setHours(0, 0, 0, 0); return fedAtMs >= t.getTime(); }
      case 'week': return fedAtMs >= now - 7 * 86400000;
      case 'month': { const m = new Date(); m.setDate(1); m.setHours(0, 0, 0, 0); return fedAtMs >= m.getTime(); }
      case '30d': return fedAtMs >= now - 30 * 86400000;
      default: return true;
    }
  }

  function populateFeedTypeFilter() {
    const sel = document.getElementById('feed-type-filter');
    if (sel) {
      const current = sel.value;
      const ids = Object.keys(feedTypes).sort((a, b) => (feedTypes[a].name || '').localeCompare(feedTypes[b].name || ''));
      sel.innerHTML = '<option value="all">All Feed Types</option>' + ids.map(id => `<option value="${id}">${feedTypes[id].name}</option>`).join('');
      sel.value = ids.includes(current) ? current : 'all';
    }
    populateFeedTypeSelect();
  }
  function populateFeedTypeSelect() {
    const sel = document.getElementById('feed-type-select');
    if (!sel) return;
    const current = sel.value;
    const ids = Object.keys(feedTypes).sort((a, b) => (feedTypes[a].name || '').localeCompare(feedTypes[b].name || ''));
    sel.innerHTML = '<option value="">Select feed type</option>' + ids.map(id => `<option value="${id}">${feedTypes[id].name}</option>`).join('');
    if (ids.includes(current)) sel.value = current;
  }
  function populateFeedingPigeonFilter() {
    const sel = document.getElementById('feed-pigeon-filter');
    if (!sel) return;
    const current = sel.value;
    const own = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug).sort((a, b) => (a.p.name || '').localeCompare(b.p.name || ''));
    sel.innerHTML = '<option value="all">All Pigeons</option>' + own.map(d => `<option value="${d.id}">${d.p.name}</option>`).join('');
    sel.value = own.some(d => d.id === current) ? current : 'all';
  }

  function renderFeedingList() {
    const tbody = document.getElementById('feed-table-body');
    const empty = document.getElementById('feed-empty');
    const tableWrap = document.getElementById('feed-table-wrap');
    const footer = document.getElementById('feed-footer');
    populateFeedingPigeonFilter();
    renderFeedingStats();
    renderFeedTypeUsage();
    renderFeedingSchedule();

    const allIds = Object.keys(feedings);
    const term = ((document.getElementById('feed-search') || {}).value || '').trim().toLowerCase();
    const dateFilter = (document.getElementById('feed-date-filter') || {}).value || 'all';
    const typeFilter = (document.getElementById('feed-type-filter') || {}).value || 'all';
    const pigeonFilter = (document.getElementById('feed-pigeon-filter') || {}).value || 'all';

    let ids = allIds.filter(id => {
      const f = feedings[id];
      const ft = f.feedTypeId ? feedTypes[f.feedTypeId] : null;
      if (term) {
        const hay = ((ft && ft.name) || '').toLowerCase() + ' ' + (f.notes || '').toLowerCase() + ' ' + (f.groupLabel || '').toLowerCase();
        if (!hay.includes(term)) return false;
      }
      if (!feedingDateMatchesFilter(f.fedAtMs, dateFilter)) return false;
      if (typeFilter !== 'all' && f.feedTypeId !== typeFilter) return false;
      if (pigeonFilter !== 'all' && !resolveFeedingPigeonIds(f).includes(pigeonFilter)) return false;
      return true;
    });
    ids.sort((a, b) => (feedings[b].fedAtMs || 0) - (feedings[a].fedAtMs || 0));

    document.getElementById('feed-count').textContent = allIds.length ? `(${allIds.length})` : '';

    if (ids.length === 0) {
      empty.style.display = 'block';
      tableWrap.style.display = 'none';
      if (footer) footer.style.display = 'none';
      document.getElementById('feed-pagination').innerHTML = '';
      document.getElementById('feed-empty-title').textContent = allIds.length === 0 ? 'No feeding entries yet.' : 'No feeding entries match your filters.';
      document.getElementById('feed-empty-text').textContent = allIds.length === 0
        ? 'Click "+ Add Feeding" above to log your first one.'
        : 'Try a different search term or filter.';
      return;
    }
    empty.style.display = 'none';
    tableWrap.style.display = '';
    if (footer) footer.style.display = '';

    const totalPages = feedingsPerPage === Infinity ? 1 : Math.max(1, Math.ceil(ids.length / feedingsPerPage));
    if (currentFeedingPage > totalPages) currentFeedingPage = totalPages;
    const startIdx = feedingsPerPage === Infinity ? 0 : (currentFeedingPage - 1) * feedingsPerPage;
    const pageIds = feedingsPerPage === Infinity ? ids : ids.slice(startIdx, startIdx + feedingsPerPage);

    renderFeedingPagination(totalPages);
    const showingEl = document.getElementById('feed-showing');
    if (showingEl) {
      showingEl.textContent = 'Showing ' + (startIdx + 1) + ' to ' + (startIdx + pageIds.length) + ' of ' + ids.length +
        ' record' + (ids.length !== 1 ? 's' : '');
    }

    tbody.innerHTML = '';
    pageIds.forEach((id, i) => {
      const f = feedings[id];
      const ft = f.feedTypeId ? feedTypes[f.feedTypeId] : null;
      const dateStr = f.fedAtMs ? fmtDateOnly(f.fedAtMs) + ', ' + fmtClock12(f.fedAtMs) : '—';
      const pigeonCount = resolveFeedingPigeonCount(f);
      const pigeonsLabel = pigeonCount !== null ? pigeonCount : (f.groupLabel || '—');
      const status = f.status === 'scheduled' ? 'scheduled' : 'completed';
      const statusBadgeClass = status === 'completed' ? 'trn-badge--completed' : 'trn-badge--planned';
      const statusLabel = status === 'completed' ? 'Completed' : 'Scheduled';
      const tr = document.createElement('tr');
      tr.innerHTML = `
        <td class="trn-col-num">${startIdx + i + 1}</td>
        <td class="feed-c-date"><span class="feed-d1">${f.fedAtMs ? fmtDateOnly(f.fedAtMs) + ',' : '—'}</span> <span class="feed-d2">${f.fedAtMs ? fmtClock12(f.fedAtMs) : ''}</span></td>
        <td class="feed-c-type"><div class="szn-name" style="display:flex;align-items:center;gap:8px;">${feedTypeAvatarHtml(ft)}<b>${ft ? ft.name : '—'}</b></div></td>
        <td class="feed-c-qty"><i class="fa-solid fa-weight-hanging feed-mob-ic"></i><span class="feed-v">${f.quantity != null ? f.quantity + ' ' + (f.unit || 'kg') : '—'}</span><span class="feed-lbl">Quantity</span></td>
        <td class="feed-c-pig"><i class="fa-solid fa-dove feed-mob-ic"></i><span class="feed-v">${pigeonsLabel}</span><span class="feed-lbl">Pigeons</span></td>
        <td class="feed-c-notes" style="max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"><i class="fa-regular fa-note-sticky feed-mob-ic"></i><span class="feed-v">${f.notes || '—'}</span><span class="feed-lbl">Notes</span></td>
        <td class="feed-c-status"><span class="pgn-badge ${statusBadgeClass}">${statusLabel}</span></td>
        <td class="trn-col-actions">
          <div class="szn-actions">
            <button type="button" class="szn-btn feed-view-btn"><i class="fa-solid fa-eye"></i> View</button>
            <button type="button" class="szn-btn feed-edit-btn"><i class="fa-solid fa-pen"></i> Edit</button>
            <div class="szn-kebab-wrap">
              <button type="button" class="ltc-kebab-btn pgn-kebab feed-kebab-btn" aria-label="More actions"><i class="fa-solid fa-ellipsis-vertical"></i></button>
              <div class="ltc-kebab-menu">
                <div class="ltc-kebab-menu-item feed-edit-item"><i class="fa-solid fa-pen"></i> Edit</div>
                <div class="ltc-kebab-menu-divider"></div>
                <div class="ltc-kebab-menu-item danger feed-delete-item"><i class="fa-solid fa-trash"></i> Delete</div>
              </div>
            </div>
          </div>
        </td>
      `;
      const kebabBtn = tr.querySelector('.feed-kebab-btn');
      const kebabMenu = tr.querySelector('.ltc-kebab-menu');
      // No separate "Feeding Details" screen was designed -- View opens the
      // same Add/Edit Feeding dialog pre-filled, same as Edit, rather than
      // inventing a whole extra read-only view that wasn't asked for.
      tr.querySelector('.feed-view-btn').onclick = (e) => { e.stopPropagation(); openEditFeedingModal(id, f); };
      tr.querySelector('.feed-edit-btn').onclick = (e) => { e.stopPropagation(); openEditFeedingModal(id, f); };
      kebabBtn.onclick = (e) => {
        e.stopPropagation();
        const wasOpen = kebabMenu.classList.contains('open');
        document.querySelectorAll('.ltc-kebab-menu.open').forEach(m => m.classList.remove('open'));
        if (!wasOpen) { kebabMenu.classList.add('open'); keepKebabMenuInView(kebabMenu); }
      };
      tr.querySelector('.feed-edit-item').onclick = (e) => { e.stopPropagation(); kebabMenu.classList.remove('open'); openEditFeedingModal(id, f); };
      tr.querySelector('.feed-delete-item').onclick = async (e) => {
        e.stopPropagation();
        kebabMenu.classList.remove('open');
        if (!(await showConfirmModal('Delete this feeding entry? This cannot be undone.', 'Delete entry?'))) return;
        try {
          await db.collection('feedings').doc(id).delete();
          delete feedings[id];
          renderFeedingList();
          showToast('🗑️ Feeding entry deleted');
        } catch (e2) { showToast('Could not delete: ' + e2.message); }
      };
      tbody.appendChild(tr);
    });
  }

  function renderFeedingPagination(totalPages) {
    const el = document.getElementById('feed-pagination');
    if (!el) return;
    el.innerHTML = '';
    if (totalPages <= 1) return;
    const prevBtn = document.createElement('button');
    prevBtn.textContent = '← Prev';
    prevBtn.disabled = currentFeedingPage === 1;
    prevBtn.onclick = () => { currentFeedingPage--; renderFeedingList(); };
    el.appendChild(prevBtn);
    for (let i = 1; i <= totalPages; i++) {
      const pageBtn = document.createElement('button');
      pageBtn.textContent = i;
      if (i === currentFeedingPage) pageBtn.className = 'active';
      pageBtn.onclick = () => { currentFeedingPage = i; renderFeedingList(); };
      el.appendChild(pageBtn);
    }
    const nextBtn = document.createElement('button');
    nextBtn.textContent = 'Next →';
    nextBtn.disabled = currentFeedingPage === totalPages;
    nextBtn.onclick = () => { currentFeedingPage++; renderFeedingList(); };
    el.appendChild(nextBtn);
  }

  // ---- Feed Type Usage (last 30 days) + Feeding Schedule -- both derived
  // live from the real feedings, never fabricated.
  function renderFeedTypeUsage() {
    const body = document.getElementById('feed-usage-body');
    const emptyEl = document.getElementById('feed-usage-empty');
    if (!body) return;
    body.querySelectorAll('.feed-usage-row').forEach(r => r.remove());
    const cutoff = Date.now() - 30 * 86400000;
    const totals = {};
    let grandTotal = 0;
    Object.values(feedings).forEach(f => {
      // Only feed actually eaten counts as "usage" -- a Scheduled (future,
      // not-yet-happened) entry shouldn't inflate these numbers.
      if (f.status === 'scheduled' || !f.fedAtMs || f.fedAtMs > Date.now() || f.fedAtMs < cutoff || !f.feedTypeId || !(f.quantity > 0)) return;
      totals[f.feedTypeId] = (totals[f.feedTypeId] || 0) + f.quantity;
      grandTotal += f.quantity;
    });
    const rows = Object.keys(totals).map(id => ({ id, qty: totals[id] })).sort((a, b) => b.qty - a.qty).slice(0, 6);
    if (!rows.length) { emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    rows.forEach(r => {
      const ft = feedTypes[r.id];
      const color = (ft && ft.colorHex) || '#8a97a3';
      const pct = grandTotal ? Math.round((r.qty / grandTotal) * 100) : 0;
      const row = document.createElement('div');
      row.className = 'feed-usage-row';
      row.innerHTML = `
        <span class="feed-usage-dot" style="background:${color};"></span>
        <span class="feed-usage-name">${ft ? ft.name : 'Unknown'}</span>
        <span class="feed-usage-track"><span class="feed-usage-fill" style="width:${pct}%;background:${color};"></span></span>
        <span class="feed-usage-pct">${pct}%</span>
        <span class="feed-usage-kg">${Math.round(r.qty * 10) / 10} kg</span>
      `;
      body.appendChild(row);
    });
  }

  function renderFeedingSchedule() {
    const body = document.getElementById('feed-sched-body');
    const emptyEl = document.getElementById('feed-sched-empty');
    if (!body) return;
    body.querySelectorAll('.feed-sched-row').forEach(r => r.remove());
    const buckets = { morning: null, midday: null, evening: null };
    const bucketOf = (h) => h < 12 ? 'morning' : (h < 17 ? 'midday' : 'evening');
    Object.values(feedings).forEach(f => {
      // Same reasoning as Feed Type Usage above -- only a feeding that
      // actually happened represents a "typical" time.
      if (f.status === 'scheduled' || !f.fedAtMs || f.fedAtMs > Date.now()) return;
      const b = bucketOf(new Date(f.fedAtMs).getHours());
      if (!buckets[b] || f.fedAtMs > buckets[b].fedAtMs) buckets[b] = f;
    });
    const labels = { morning: 'Morning Feed', midday: 'Midday Feed', evening: 'Evening Feed' };
    const order = ['morning', 'midday', 'evening'].filter(k => buckets[k]);
    if (!order.length) { emptyEl.style.display = 'block'; return; }
    emptyEl.style.display = 'none';
    order.forEach(k => {
      const f = buckets[k];
      const ft = f.feedTypeId ? feedTypes[f.feedTypeId] : null;
      const row = document.createElement('div');
      row.className = 'feed-sched-row';
      row.innerHTML = `
        <span class="feed-sched-time">${fmtClock12(f.fedAtMs)}</span>
        ${feedTypeAvatarHtml(ft, 'feed-sched-avatar')}
        <div class="feed-sched-text"><b>${labels[k]}</b><span>${ft ? ft.name : 'Feed'}</span></div>
      `;
      body.appendChild(row);
    });
  }

  // ---- Feed Type card picker (right column of Add/Edit Feeding) -- kept
  // in sync with the Feed Type <select> in both directions.
  function selectFeedType(id) {
    feedingSelectedFeedTypeId = id;
    const sel = document.getElementById('feed-type-select');
    if (sel) sel.value = id || '';
    renderFeedTypeCards();
  }
  function renderFeedTypeCards() {
    const grid = document.getElementById('feed-type-cards');
    const emptyEl = document.getElementById('feedtype-empty');
    if (!grid) return;
    const ids = Object.keys(feedTypes).sort((a, b) => (feedTypes[a].name || '').localeCompare(feedTypes[b].name || ''));
    if (!ids.length) { grid.innerHTML = ''; if (emptyEl) emptyEl.style.display = 'block'; return; }
    if (emptyEl) emptyEl.style.display = 'none';
    grid.innerHTML = ids.map(id => {
      const ft = feedTypes[id];
      const sel = id === feedingSelectedFeedTypeId;
      return `<div class="feedtype-card${sel ? ' selected' : ''}" data-id="${id}">
        ${feedTypeAvatarHtml(ft)}
        <div class="feedtype-card-text"><b>${ft.name}</b>${ft.description ? `<span>${ft.description}</span>` : ''}</div>
        <span class="feedtype-check"></span>
      </div>`;
    }).join('');
    grid.querySelectorAll('.feedtype-card').forEach(card => { card.onclick = () => selectFeedType(card.dataset.id); });
  }
  const feedTypeSelectEl = document.getElementById('feed-type-select');
  if (feedTypeSelectEl) feedTypeSelectEl.onchange = (e) => selectFeedType(e.target.value);

  // ---- Pigeons scope (All / Select Pigeons / Select Group).
  function updateFeedPigeonScopeUI() {
    const noteEl = document.getElementById('feed-pigeon-note');
    const countEl = document.getElementById('feed-pigeon-note-count');
    const pickerEl = document.getElementById('feed-pigeon-picker');
    const groupEl = document.getElementById('feed-group-label');
    if (!noteEl) return;
    const ownCount = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug).length;
    if (feedingPigeonScope === 'select') {
      noteEl.style.display = 'none'; pickerEl.style.display = ''; groupEl.style.display = 'none';
      renderFeedPigeonPicker();
    } else if (feedingPigeonScope === 'group') {
      noteEl.style.display = 'none'; pickerEl.style.display = 'none'; groupEl.style.display = '';
    } else {
      noteEl.style.display = ''; countEl.textContent = ownCount; pickerEl.style.display = 'none'; groupEl.style.display = 'none';
    }
  }
  function renderFeedPigeonPicker() {
    const wrap = document.getElementById('feed-pigeon-picker');
    if (!wrap) return;
    const own = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug);
    wrap.innerHTML = own.map(d => {
      const sel = feedingSelectedPigeonIds.has(d.id);
      return `<label class="trn-pcard${sel ? ' selected' : ''}"><input type="checkbox" data-id="${d.id}" ${sel ? 'checked' : ''}>${pigeonAvatarHtml(d.p)}<div class="trn-pcard-text"><b>${d.p.name}</b><span>${d.p.ringNumber || ''}</span></div></label>`;
    }).join('');
    wrap.querySelectorAll('input[type=checkbox]').forEach(cb => {
      cb.onchange = () => {
        if (cb.checked) feedingSelectedPigeonIds.add(cb.dataset.id); else feedingSelectedPigeonIds.delete(cb.dataset.id);
        cb.closest('.trn-pcard').classList.toggle('selected', cb.checked);
      };
    });
  }
  document.querySelectorAll('input[name="feed-pigeon-scope"]').forEach(radio => {
    radio.onchange = () => { feedingPigeonScope = radio.value; updateFeedPigeonScopeUI(); };
  });

  const feedNotesEl = document.getElementById('feed-notes');
  if (feedNotesEl) feedNotesEl.addEventListener('input', () => {
    document.getElementById('feed-notes-count').textContent = feedNotesEl.value.length;
  });

  const feedSearchEl = document.getElementById('feed-search');
  if (feedSearchEl) feedSearchEl.oninput = () => { currentFeedingPage = 1; renderFeedingList(); };
  ['feed-date-filter', 'feed-type-filter', 'feed-pigeon-filter'].forEach(id => {
    const el = document.getElementById(id);
    if (el) el.onchange = () => { currentFeedingPage = 1; renderFeedingList(); };
  });
  const feedPerPageEl = document.getElementById('feed-per-page');
  if (feedPerPageEl) feedPerPageEl.onchange = (e) => {
    feedingsPerPage = e.target.value === 'all' ? Infinity : parseInt(e.target.value, 10);
    currentFeedingPage = 1;
    renderFeedingList();
  };

  function resetFeedingModalFields() {
    const now = new Date();
    document.getElementById('feed-date').value = now.toISOString().slice(0, 10);
    document.getElementById('feed-date').max = now.toISOString().slice(0, 10);
    document.getElementById('feed-time').value = String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0');
    populateFeedTypeSelect();
    feedingSelectedFeedTypeId = null;
    document.getElementById('feed-type-select').value = '';
    document.getElementById('feed-quantity').value = '';
    document.getElementById('feed-unit').value = 'kg';
    document.getElementById('feed-status-select').value = 'completed';
    feedingPigeonScope = 'all';
    document.getElementById('feed-scope-all').checked = true;
    feedingSelectedPigeonIds = new Set();
    document.getElementById('feed-group-label').value = '';
    document.getElementById('feed-notes').value = '';
    document.getElementById('feed-notes-count').textContent = '0';
    document.getElementById('feed-status-msg').textContent = '';
    updateFeedPigeonScopeUI();
    renderFeedTypeCards();
  }
  function openAddFeedingModal() {
    editingFeedingId = null;
    document.getElementById('db-feeding-modal-title').textContent = 'Add Feeding';
    document.getElementById('db-feeding-modal-mback-label').textContent = 'Add Feeding';
    document.getElementById('db-feeding-modal-subtitle').textContent = 'Record a new feeding for your pigeons.';
    document.getElementById('feed-save-label').textContent = 'Save Feeding';
    resetFeedingModalFields();
    document.getElementById('db-feeding-modal').classList.add('open');
  }
  function openEditFeedingModal(id, f) {
    editingFeedingId = id;
    document.getElementById('db-feeding-modal-title').textContent = 'Edit Feeding';
    document.getElementById('db-feeding-modal-mback-label').textContent = 'Edit Feeding';
    document.getElementById('db-feeding-modal-subtitle').textContent = 'Update this feeding record.';
    document.getElementById('feed-save-label').textContent = 'Update Feeding';
    populateFeedTypeSelect();
    const d = f.fedAtMs ? new Date(f.fedAtMs) : new Date();
    document.getElementById('feed-date').max = new Date().toISOString().slice(0, 10);
    document.getElementById('feed-date').value = d.toISOString().slice(0, 10);
    document.getElementById('feed-time').value = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    feedingSelectedFeedTypeId = f.feedTypeId || null;
    document.getElementById('feed-type-select').value = f.feedTypeId || '';
    document.getElementById('feed-quantity').value = f.quantity != null ? f.quantity : '';
    document.getElementById('feed-unit').value = f.unit || 'kg';
    document.getElementById('feed-status-select').value = f.status === 'scheduled' ? 'scheduled' : 'completed';
    feedingPigeonScope = f.pigeonScope === 'select' || f.pigeonScope === 'group' ? f.pigeonScope : 'all';
    document.getElementById('feed-scope-' + feedingPigeonScope).checked = true;
    feedingSelectedPigeonIds = new Set(f.pigeonIds || []);
    document.getElementById('feed-group-label').value = f.groupLabel || '';
    document.getElementById('feed-notes').value = f.notes || '';
    document.getElementById('feed-notes-count').textContent = (f.notes || '').length;
    document.getElementById('feed-status-msg').textContent = '';
    updateFeedPigeonScopeUI();
    renderFeedTypeCards();
    document.getElementById('db-feeding-modal').classList.add('open');
  }
  const feedAddBtn = document.getElementById('feed-add-btn');
  if (feedAddBtn) feedAddBtn.onclick = openAddFeedingModal;
  const feedCancelBtn = document.getElementById('feed-cancel');
  if (feedCancelBtn) feedCancelBtn.onclick = () => document.getElementById('db-feeding-modal').classList.remove('open');
  const feedSaveBtn = document.getElementById('feed-save');
  if (feedSaveBtn) feedSaveBtn.onclick = async () => {
    const statusEl = document.getElementById('feed-status-msg');
    try {
      const feedDate = document.getElementById('feed-date').value;
      const feedTime = document.getElementById('feed-time').value;
      const feedTypeId = document.getElementById('feed-type-select').value;
      const quantity = parseFloat(document.getElementById('feed-quantity').value);
      const unit = document.getElementById('feed-unit').value;
      const status = document.getElementById('feed-status-select').value;
      const scope = feedingPigeonScope;
      const groupLabel = document.getElementById('feed-group-label').value.trim();
      const notes = document.getElementById('feed-notes').value.trim();

      if (!feedDate || !feedTime || !feedTypeId || isNaN(quantity) || quantity <= 0) {
        statusEl.textContent = 'Date, time, feed type and a quantity above 0 are required.';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Date, time, feed type and quantity are required');
        return;
      }
      if (scope === 'select' && feedingSelectedPigeonIds.size === 0) {
        statusEl.textContent = 'Select at least one pigeon, or choose "All Pigeons".';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Select at least one pigeon');
        return;
      }
      if (scope === 'group' && !groupLabel) {
        statusEl.textContent = 'Enter a group name, or choose "All Pigeons".';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Enter a group name');
        return;
      }
      const fedAtMs = new Date(feedDate + 'T' + feedTime).getTime();
      if (status === 'completed' && fedAtMs > Date.now()) {
        statusEl.textContent = 'A Completed feeding can\'t be dated in the future -- use Scheduled instead.';
        statusEl.style.color = '#c0392b';
        showToast('⚠️ Completed feedings can\'t be in the future');
        return;
      }
      statusEl.textContent = 'Saving...';
      statusEl.style.color = '#6b7a87';
      const data = {
        fedAtMs, feedTypeId, quantity, unit, status,
        pigeonScope: scope,
        pigeonIds: scope === 'select' ? Array.from(feedingSelectedPigeonIds) : [],
        groupLabel: scope === 'group' ? groupLabel : null,
        notes: notes || null,
        orgId: currentOrg.slug, ownerUid: auth.currentUser.uid
      };
      if (editingFeedingId) {
        await db.collection('feedings').doc(editingFeedingId).update(data);
        feedings[editingFeedingId] = { ...feedings[editingFeedingId], ...data };
      } else {
        const ref = await db.collection('feedings').add({ ...data, createdAt: firebase.firestore.FieldValue.serverTimestamp() });
        feedings[ref.id] = data;
      }
      renderFeedingList();
      showToast(editingFeedingId ? '✅ Feeding updated' : '✅ Feeding saved');
      document.getElementById('db-feeding-modal').classList.remove('open');
    } catch (e) {
      console.error('Feeding save failed:', e);
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
      showToast('❌ Could not save feeding: ' + e.message);
    }
  };

  // ---- Add Feed Type modal -- opened from inside Add/Edit Feeding; saving
  // immediately refreshes the Feed Type <select> + card grid in that still-
  // open Feeding modal and selects the new type.
  function setFeedTypePhotoPreview(url) {
    const el = document.getElementById('feedtype-photo-preview');
    if (!el) return;
    el.innerHTML = url ? '<img src="' + url + '" alt="">' : '<i class="fa-solid fa-wheat-awn"></i>';
  }
  function openAddFeedTypeModal() {
    document.getElementById('feedtype-name').value = '';
    document.getElementById('feedtype-desc').value = '';
    document.getElementById('feedtype-photo').value = '';
    setFeedTypePhotoPreview(null);
    document.getElementById('feedtype-status-msg').textContent = '';
    document.getElementById('db-feedtype-modal').classList.add('open');
  }
  const feedAddTypeBtn = document.getElementById('feed-addtype-btn');
  if (feedAddTypeBtn) feedAddTypeBtn.onclick = openAddFeedTypeModal;
  const feedTypeCancelBtn = document.getElementById('feedtype-cancel');
  if (feedTypeCancelBtn) feedTypeCancelBtn.onclick = () => document.getElementById('db-feedtype-modal').classList.remove('open');
  const feedTypePhotoBtn = document.getElementById('feedtype-photo-btn');
  const feedTypePhotoInput = document.getElementById('feedtype-photo');
  if (feedTypePhotoBtn && feedTypePhotoInput) {
    feedTypePhotoBtn.onclick = () => feedTypePhotoInput.click();
    feedTypePhotoInput.onchange = () => {
      const f = feedTypePhotoInput.files && feedTypePhotoInput.files[0];
      if (!f) return;
      if (!/^image\//.test(f.type)) { showToast('Please choose an image (JPG or PNG).'); feedTypePhotoInput.value = ''; return; }
      if (f.size > 5 * 1024 * 1024) { showToast('That image is over 5MB -- please choose a smaller one.'); feedTypePhotoInput.value = ''; return; }
      setFeedTypePhotoPreview(URL.createObjectURL(f));
    };
  }
  const feedTypeSaveBtn = document.getElementById('feedtype-save');
  if (feedTypeSaveBtn) feedTypeSaveBtn.onclick = async () => {
    const statusEl = document.getElementById('feedtype-status-msg');
    const name = document.getElementById('feedtype-name').value.trim();
    const description = document.getElementById('feedtype-desc').value.trim();
    const photoFile = document.getElementById('feedtype-photo').files[0];
    if (!name) {
      statusEl.textContent = 'Name is required.';
      statusEl.style.color = '#c0392b';
      return;
    }
    statusEl.textContent = 'Saving...';
    statusEl.style.color = '#6b7a87';
    try {
      let photoURL = null;
      if (photoFile) {
        const path = 'feedTypes/' + currentOrg.slug + '/' + Date.now() + '_' + photoFile.name;
        const storageInstance = await getStorage();
        const ref = storageInstance.ref().child(path);
        await ref.put(photoFile);
        photoURL = await ref.getDownloadURL();
      }
      const data = {
        name, description: description || null, photoURL, colorHex: pickAutoFeedTypeColor(),
        orgId: currentOrg.slug, ownerUid: auth.currentUser.uid,
        createdAt: firebase.firestore.FieldValue.serverTimestamp()
      };
      const newRef = await db.collection('feedTypes').add(data);
      feedTypes[newRef.id] = data;
      populateFeedTypeFilter();
      renderFeedTypeCards();
      selectFeedType(newRef.id);
      showToast('✅ Feed type saved');
      document.getElementById('db-feedtype-modal').classList.remove('open');
    } catch (e) {
      console.error('Feed type save failed:', e);
      statusEl.textContent = e.message;
      statusEl.style.color = '#c0392b';
      showToast('❌ Could not save feed type: ' + e.message);
    }
  };

  // ---- Quick Log Arrival: a dialog built for standing at the loft with a
  // phone -- tap a pigeon the instant it drops and its arrival time (now)
  // is written immediately, with speed computed from the training's
  // distance and elapsed time. No typing; "Save All Arrivals" just keeps
  // the optional notes and closes, since every tap is already saved.
  let quicklogTrainingId = null;

  function quicklogTimeStr(ms) { return new Date(ms).toTimeString().slice(0, 5); }
  function quicklogEligibleIds() {
    // Only trainings that have actually been released can have arrivals.
    return Object.keys(trainings)
      .filter(id => (trainings[id].releaseAtMs || 0) <= Date.now())
      .sort((a, b) => (trainings[b].releaseAtMs || 0) - (trainings[a].releaseAtMs || 0));
  }

  function populateQuicklogTrainingSelect() {
    const el = document.getElementById('quicklog-training-select');
    const ids = quicklogEligibleIds();
    el.innerHTML = ids.map(id => `<option value="${id}">${trainingNameOf(trainings[id])}</option>`).join('') ||
      '<option value="">No trainings yet</option>';
  }

  function openQuickLogPage(preferredTrainingId) {
    if (preferredTrainingId && trainings[preferredTrainingId] && (trainings[preferredTrainingId].releaseAtMs || 0) > Date.now()) {
      showToast('This training hasn\'t been released yet -- arrivals can be logged once it starts.');
      return;
    }
    populateQuicklogTrainingSelect();
    const el = document.getElementById('quicklog-training-select');
    if (preferredTrainingId && trainings[preferredTrainingId]) el.value = preferredTrainingId;
    quicklogTrainingId = el.value || null;
    document.getElementById('quicklog-search').value = '';
    document.getElementById('quicklog-add-picker').classList.remove('open');
    renderQuicklogPage();
    loadQuicklogNotes();
    document.getElementById('db-quicklog-modal').classList.add('open');
  }

  function renderQuicklogPage() {
    const t = trainings[quicklogTrainingId];
    const gridEl = document.getElementById('quicklog-pending-grid');
    const homeEl = document.getElementById('quicklog-home-list');
    const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
    if (!t) {
      set('quicklog-train-sub', 'No trainings released yet -- add one first.');
      set('quicklog-progress-text', '0 / 0 home');
      document.getElementById('quicklog-progress-bar').style.width = '0%';
      set('quicklog-list-title', 'Arrival List (0 / 0)');
      gridEl.innerHTML = '<div class="trn-pick-empty">No active trainings -- add one first.</div>';
      homeEl.innerHTML = '';
      document.getElementById('quicklog-details').innerHTML = '';
      document.getElementById('quicklog-notes').value = '';
      document.getElementById('quicklog-clear-btn').disabled = true;
      return;
    }
    const pigeonIds = t.participatingPigeonIds || [];
    const arrivals = t.arrivals || {};
    const arrivedIds = pigeonIds.filter(id => arrivals[id]);
    // The search box only filters which cards are SHOWN (by pigeon name or
    // ring number) -- the home count, progress bar and Arrival List above and
    // beside it always cover the whole training.
    const searchTerm = ((document.getElementById('quicklog-search') || {}).value || '').trim().toLowerCase();
    const visibleIds = !searchTerm ? pigeonIds : pigeonIds.filter(pid => {
      const doc = allPigeonDocs.find(d => d.id === pid);
      const p = doc ? doc.p : null;
      return ((p && p.name) || '').toLowerCase().includes(searchTerm) || ((p && p.ringNumber) || '').toLowerCase().includes(searchTerm);
    });
    const pct = pigeonIds.length ? Math.round(arrivedIds.length / pigeonIds.length * 100) : 0;

    set('quicklog-train-sub', 'Released ' + fmtDateOnly(t.releaseAtMs) + ' ' + quicklogTimeStr(t.releaseAtMs) + ' · ' + (t.distanceKm || 0) + ' km');
    set('quicklog-progress-text', arrivedIds.length + ' / ' + pigeonIds.length + ' home');
    document.getElementById('quicklog-progress-bar').style.width = pct + '%';
    set('quicklog-list-title', 'Arrival List (' + arrivedIds.length + ' / ' + pigeonIds.length + ')');
    set('quicklog-autocalc-text', 'Based on release time: ' + new Date(t.releaseAtMs).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }));
    document.getElementById('quicklog-clear-btn').disabled = arrivedIds.length === 0;

    // Training details card
    document.getElementById('quicklog-details').innerHTML = `
      <div class="ql-detail"><i class="fa-regular fa-calendar"></i><div><span>Date</span><b>${fmtDateOnly(t.releaseAtMs)}</b></div></div>
      <div class="ql-detail"><i class="fa-solid fa-location-dot"></i><div><span>Location</span><b>${t.releasePoint || '—'}</b></div></div>
      <div class="ql-detail"><i class="fa-solid fa-route"></i><div><span>Distance</span><b>${t.distanceKm || 0} km</b></div></div>
      <div class="ql-detail"><i class="fa-regular fa-clock"></i><div><span>Released</span><b>${new Date(t.releaseAtMs).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}</b></div></div>`;

    // One card per participating pigeon: tap a pending one to record its arrival now.
    gridEl.innerHTML = visibleIds.map(pid => {
      const doc = allPigeonDocs.find(d => d.id === pid);
      const p = doc ? doc.p : null;
      const a = arrivals[pid];
      return `
        <div class="ql-card${a ? ' ql-card--arrived' : ''}" data-id="${pid}">
          ${a ? '<span class="ql-check"><i class="fa-solid fa-check"></i></span>' : ''}
          <div class="ql-card-top">
            ${pigeonAvatarHtml(p)}
            <div class="ql-card-text"><b>${p ? p.name : 'Unknown'}</b><span>${p && p.ringNumber ? p.ringNumber : pid}</span></div>
          </div>
          <div class="ql-pill">${a ? 'Arrived ' + quicklogTimeStr(a.arrivedAtMs) : 'Pending'}</div>
        </div>`;
    }).join('') + (searchTerm && visibleIds.length === 0 ? '<div class="trn-pick-empty">No pigeons match your search.</div>' : '') + `
        <div class="ql-card ql-card--add" id="quicklog-add-tile" role="button" tabindex="0">
          <i class="fa-solid fa-plus"></i><b>Add Pigeon</b><span>(Optional)</span>
        </div>`;
    gridEl.querySelectorAll('.ql-card[data-id]').forEach(card => {
      if (!card.classList.contains('ql-card--arrived')) card.onclick = () => logArrivalNow(card.dataset.id);
    });
    const addTile = document.getElementById('quicklog-add-tile');
    addTile.onclick = () => openQuicklogAddPicker();

    // Arrival list, in the order they came home
    const sorted = arrivedIds.slice().sort((a, b) => arrivals[a].arrivedAtMs - arrivals[b].arrivedAtMs);
    homeEl.innerHTML = sorted.length === 0
      ? '<div class="db-empty-small">No arrivals logged yet.</div>'
      : sorted.map(pid => {
          const doc = allPigeonDocs.find(d => d.id === pid);
          const p = doc ? doc.p : null;
          const a = arrivals[pid];
          return `
            <div class="ql-row">
              ${pigeonAvatarHtml(p)}
              <div class="ql-row-text"><b>${p ? p.name : 'Unknown'}</b><span>${p && p.ringNumber ? p.ringNumber : pid}</span></div>
              <span class="ql-time">${quicklogTimeStr(a.arrivedAtMs)}</span>
              <button type="button" class="ql-undo" data-id="${pid}" title="Undo this arrival"><i class="fa-solid fa-rotate-left"></i></button>
            </div>`;
        }).join('');
    homeEl.querySelectorAll('.ql-undo').forEach(btn => { btn.onclick = () => undoArrival(btn.dataset.id); });
  }
  function loadQuicklogNotes() {
    const t = trainings[quicklogTrainingId];
    document.getElementById('quicklog-notes').value = (t && t.arrivalNotes) || '';
  }

  // Refreshes whatever else is showing this training's arrivals.
  function afterArrivalsChanged() {
    renderQuicklogPage();
    renderTrainingsList();
    if (document.getElementById('db-trndet-modal').classList.contains('open')) renderTrainingDetailModal();
  }

  async function logArrivalNow(pigeonId) {
    const t = trainings[quicklogTrainingId];
    if (!t) return;
    const arrivedAtMs = Date.now();
    if (arrivedAtMs < (t.releaseAtMs || 0)) { showToast('This training hasn\'t been released yet.'); return; }
    const hours = (arrivedAtMs - t.releaseAtMs) / 3600000;
    const speedKmH = hours > 0 ? t.distanceKm / hours : 0;
    const newArrivals = { ...(t.arrivals || {}), [pigeonId]: { arrivedAtMs, speedKmH } };
    try {
      await db.collection('trainings').doc(quicklogTrainingId).update({ arrivals: newArrivals });
      trainings[quicklogTrainingId].arrivals = newArrivals;
      afterArrivalsChanged();
      showToast('✅ Arrival logged');
    } catch (e) {
      showToast('❌ Could not log arrival: ' + e.message);
    }
  }
  async function undoArrival(pigeonId) {
    const t = trainings[quicklogTrainingId];
    if (!t) return;
    const newArrivals = { ...(t.arrivals || {}) };
    delete newArrivals[pigeonId];
    try {
      await db.collection('trainings').doc(quicklogTrainingId).update({ arrivals: newArrivals });
      trainings[quicklogTrainingId].arrivals = newArrivals;
      afterArrivalsChanged();
      showToast('Arrival removed');
    } catch (e) {
      showToast('❌ Could not undo: ' + e.message);
    }
  }
  async function clearAllArrivals() {
    const t = trainings[quicklogTrainingId];
    if (!t || Object.keys(t.arrivals || {}).length === 0) return;
    if (!(await showConfirmModal('Remove every logged arrival for this training? The pigeons go back to Pending.', 'Clear all arrivals?', 'Clear All'))) return;
    try {
      await db.collection('trainings').doc(quicklogTrainingId).update({ arrivals: {} });
      trainings[quicklogTrainingId].arrivals = {};
      afterArrivalsChanged();
      showToast('All arrivals cleared');
    } catch (e) {
      showToast('❌ Could not clear: ' + e.message);
    }
  }

  // "Add Pigeon (Optional)": add one more of this account's pigeons to the
  // training's participant list without leaving the dialog.
  function openQuicklogAddPicker() {
    const t = trainings[quicklogTrainingId];
    if (!t) return;
    const taken = new Set(t.participatingPigeonIds || []);
    const available = allPigeonDocs.filter(d => d.p.orgId === currentOrg.slug && !taken.has(d.id));
    if (available.length === 0) { showToast('All your pigeons are already in this training.'); return; }
    const sel = document.getElementById('quicklog-add-select');
    sel.innerHTML = available.map(d => `<option value="${d.id}">${d.p.name}${d.p.ringNumber ? ' (' + d.p.ringNumber + ')' : ''}</option>`).join('');
    document.getElementById('quicklog-add-picker').classList.add('open');
  }
  async function addPigeonToQuicklogTraining() {
    const t = trainings[quicklogTrainingId];
    const pid = document.getElementById('quicklog-add-select').value;
    if (!t || !pid) return;
    const ids = Array.from(new Set([...(t.participatingPigeonIds || []), pid]));
    try {
      await db.collection('trainings').doc(quicklogTrainingId).update({ participatingPigeonIds: ids });
      trainings[quicklogTrainingId].participatingPigeonIds = ids;
      document.getElementById('quicklog-add-picker').classList.remove('open');
      afterArrivalsChanged();
      showToast('✅ Pigeon added to this training');
    } catch (e) {
      showToast('❌ Could not add pigeon: ' + e.message);
    }
  }

  (function wireQuickLog() {
    const sel = document.getElementById('quicklog-training-select');
    if (sel) sel.onchange = (e) => { quicklogTrainingId = e.target.value; document.getElementById('quicklog-search').value = ''; document.getElementById('quicklog-add-picker').classList.remove('open'); renderQuicklogPage(); loadQuicklogNotes(); };
    document.getElementById('quicklog-search').addEventListener('input', () => renderQuicklogPage());
    document.getElementById('quicklog-clear-btn').onclick = () => clearAllArrivals();
    document.getElementById('quicklog-close-btn').onclick = () => document.getElementById('db-quicklog-modal').classList.remove('open');
    document.getElementById('quicklog-save-btn').onclick = async () => {
      const t = trainings[quicklogTrainingId];
      const modalEl = document.getElementById('db-quicklog-modal');
      if (!t) { modalEl.classList.remove('open'); return; }
      const notes = document.getElementById('quicklog-notes').value.trim();
      try {
        if (notes !== (t.arrivalNotes || '')) {
          await db.collection('trainings').doc(quicklogTrainingId).update({ arrivalNotes: notes });
          trainings[quicklogTrainingId].arrivalNotes = notes;
        }
        showToast('✅ Arrivals saved');
        modalEl.classList.remove('open');
      } catch (e) {
        showToast('❌ Could not save notes: ' + e.message);
      }
    };
    document.getElementById('quicklog-add-confirm').onclick = () => addPigeonToQuicklogTraining();
    document.getElementById('quicklog-add-cancel').onclick = () => document.getElementById('quicklog-add-picker').classList.remove('open');
    const openBtn = document.getElementById('trn-quicklog-btn');
    if (openBtn) openBtn.onclick = () => openQuickLogPage();
  })();

  // ---- Ace Pigeons + Training Details, both as dialogs over the Trainings
  // page. Every number below is read straight from the stored trainings:
  // participants, arrivals, release time and distance. Nothing is scored or
  // invented -- the Ace table is just each pigeon's own training record.

  // "1h 12m" for a flight of an hour or more, "12m 30s" for shorter ones.
  function fmtFlightTime(ms) {
    if (!(ms >= 0)) return '—';
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.round((ms % 60000) / 1000);
    return h > 0 ? h + 'h ' + m + 'm' : m + 'm ' + s + 's';
  }
  function fmtClock12(ms) {
    return new Date(ms).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }
  function fmtPct(x) { return (Math.round(x * 10) / 10) + '%'; }

  // ----- Ace Pigeons
  const ACE_RANGE_DAYS = { all: null, '30': 30, '90': 90, '180': 180, '365': 365 };

  function populateAceSeasonSelect() {
    const el = document.getElementById('ace-season');
    const prev = el.value;
    const seasonIds = Object.keys(seasons).sort((a, b) => (seasons[b].year || 0) - (seasons[a].year || 0));
    el.innerHTML = '<option value="all">All Seasons</option>' +
      seasonIds.map(id => `<option value="${id}">${seasons[id].name} (${seasons[id].year})</option>`).join('');
    if ([...el.options].some(o => o.value === prev)) el.value = prev;
  }

  function renderAceModal() {
    const now = Date.now();
    const seasonSel = document.getElementById('ace-season').value;
    const days = ACE_RANGE_DAYS[document.getElementById('ace-range').value];
    const cutoff = days ? now - days * 86400000 : null;
    const term = document.getElementById('ace-search').value.trim().toLowerCase();

    // Only trainings that have actually been released can have results.
    const included = Object.keys(trainings).map(id => trainings[id]).filter(t => {
      if ((t.releaseAtMs || 0) > now) return false;
      if (seasonSel !== 'all' && t.seasonId !== seasonSel) return false;
      if (cutoff !== null && (t.releaseAtMs || 0) < cutoff) return false;
      return true;
    });

    const per = {}; // pigeonId -> { trainings, returned, bestMs, distance }
    included.forEach(t => {
      const arrivals = t.arrivals || {};
      (t.participatingPigeonIds || []).forEach(pid => {
        const s = per[pid] || (per[pid] = { trainings: 0, returned: 0, bestMs: null, distance: 0 });
        s.trainings++;
        const a = arrivals[pid];
        if (a) {
          s.returned++;
          const flight = a.arrivedAtMs - t.releaseAtMs;
          if (flight >= 0 && (s.bestMs === null || flight < s.bestMs)) s.bestMs = flight;
          s.distance += (t.distanceKm || 0);
        }
      });
    });

    let rows = Object.keys(per).map(pid => {
      const doc = allPigeonDocs.find(d => d.id === pid);
      return doc ? Object.assign({ pid, doc }, per[pid], { rate: per[pid].trainings ? per[pid].returned / per[pid].trainings * 100 : 0 }) : null;
    }).filter(Boolean);
    const totalRecords = rows.reduce((n, r) => n + r.trainings, 0);
    const totalReturned = rows.reduce((n, r) => n + r.returned, 0);
    if (term) rows = rows.filter(r => (r.doc.p.name || '').toLowerCase().includes(term) || (r.doc.p.ringNumber || '').toLowerCase().includes(term));
    // Ordered by each pigeon's own return rate, then returns, then trainings flown, then best flight.
    rows.sort((a, b) => b.rate - a.rate || b.returned - a.returned || b.trainings - a.trainings || (a.bestMs === null) - (b.bestMs === null) || (a.bestMs || 0) - (b.bestMs || 0));

    document.getElementById('ace-stat-pigeons').textContent = Object.keys(per).filter(pid => allPigeonDocs.some(d => d.id === pid)).length;
    document.getElementById('ace-stat-rate').textContent = totalRecords ? Math.round(totalReturned / totalRecords * 100) + '%' : '—';
    document.getElementById('ace-stat-trainings').textContent = included.length;

    const tbody = document.getElementById('ace-tbody');
    if (rows.length === 0) {
      tbody.innerHTML = '<tr class="ace-empty-row"><td colspan="9">' + (Object.keys(per).length === 0
        ? 'No training results yet for this selection.' : 'No pigeons match your search.') + '</td></tr>';
      return;
    }
    tbody.innerHTML = rows.map((r, i) => {
      const p = r.doc.p;
      const rateCls = r.rate >= 90 ? 'ace-rate--high' : 'ace-rate--mid';
      return `
        <tr>
          <td class="ace-c-rank" data-label="Rank">${i + 1}</td>
          <td class="ace-c-avatar">${pigeonAvatarHtml(p)}</td>
          <td class="ace-c-name"><b>${p.name}</b><span class="ace-ring-m">${p.ringNumber || 'No ring number'}</span></td>
          <td class="ace-c-ring" data-label="Ring Number">${p.ringNumber || '—'}</td>
          <td data-label="Trainings">${r.trainings}</td>
          <td data-label="Returned">${r.returned}</td>
          <td data-label="Return Rate"><span class="ace-rate ${rateCls}">${Math.round(r.rate)}%</span></td>
          <td data-label="Best Flight Time">${r.bestMs === null ? '—' : fmtFlightTime(r.bestMs)}</td>
          <td data-label="Total Distance">${Math.round(r.distance * 10) / 10} km</td>
        </tr>`;
    }).join('');
  }

  function openAceModal() {
    populateAceSeasonSelect();
    document.getElementById('ace-search').value = '';
    renderAceModal();
    document.getElementById('db-ace-modal').classList.add('open');
  }
  (function wireAceModal() {
    ['ace-season', 'ace-range'].forEach(id => { document.getElementById(id).onchange = renderAceModal; });
    document.getElementById('ace-search').addEventListener('input', renderAceModal);
    document.getElementById('ace-close-btn').onclick = () => document.getElementById('db-ace-modal').classList.remove('open');
  })();

  // ----- Training Details
  let tdmTrainingId = null;

  // Returned = has a logged arrival. No arrival: Pending while the training
  // hasn't finished (or was released under 24h ago and may still be coming
  // home); Missing once a Completed training is over a day old with no arrival.
  function tdmStatusOf(t, pid) {
    if ((t.arrivals || {})[pid]) return 'returned';
    const sinceRelease = Date.now() - (t.releaseAtMs || 0);
    if (trainingStatusOf(t) === 'completed' && sinceRelease > 24 * 3600000) return 'missing';
    return 'pending';
  }

  function renderTrainingDetailModal() {
    const t = trainings[tdmTrainingId];
    if (!t) return;
    const arrivals = t.arrivals || {};
    const pigeonIds = t.participatingPigeonIds || [];
    const statuses = {};
    pigeonIds.forEach(pid => { statuses[pid] = tdmStatusOf(t, pid); });
    const returned = pigeonIds.filter(pid => statuses[pid] === 'returned').length;
    const missing = pigeonIds.filter(pid => statuses[pid] === 'missing').length;
    const rate = pigeonIds.length ? returned / pigeonIds.length * 100 : 0;
    const season = t.seasonId ? seasons[t.seasonId] : null;
    const status = trainingStatusOf(t);
    const releaseDate = fmtDateOnly(t.releaseAtMs);
    const releaseClock24 = new Date(t.releaseAtMs).toTimeString().slice(0, 5);

    document.getElementById('tdm-info').innerHTML = `
      <div class="tdm-info-left">
        <div class="tdm-name-row"><b>${trainingNameOf(t)}</b><span class="pgn-badge trn-badge--${status}">${TRAINING_STATUS_META[status].label}</span></div>
        <div class="tdm-date"><i class="fa-regular fa-calendar"></i><div><span>${releaseDate}</span><span>${releaseClock24}</span></div></div>
      </div>
      <div class="tdm-info-grid">
        <div class="tdm-fact"><i class="fa-solid fa-calendar-days"></i><div><span>Season</span><b>${season ? season.name + ' (' + season.year + ')' : '—'}</b></div></div>
        <div class="tdm-fact"><i class="fa-solid fa-location-dot"></i><div><span>Release Location</span><b>${t.releasePoint || '—'}</b></div></div>
        <div class="tdm-fact"><i class="fa-solid fa-route"></i><div><span>Distance</span><b>${t.distanceKm || 0} km</b></div></div>
        <div class="tdm-fact"><i class="fa-regular fa-clock"></i><div><span>Release Time</span><b>${fmtClock12(t.releaseAtMs)}</b></div></div>
        <div class="tdm-fact"><i class="fa-solid fa-dove"></i><div><span>Pigeons Released</span><b>${pigeonIds.length}</b></div></div>
      </div>`;

    document.getElementById('tdm-summary').innerHTML = `
      <div class="tdm-sum-title"><i class="fa-solid fa-chart-simple"></i> Training Summary</div>
      <div class="tdm-sum-grid">
        <div class="tdm-sum"><span><i class="fa-solid fa-dove"></i> Pigeons Released</span><b>${pigeonIds.length}</b></div>
        <div class="tdm-sum"><span><i class="fa-solid fa-check tdm-ok"></i> Returned</span><b>${returned}</b></div>
        <div class="tdm-sum"><span><i class="fa-solid fa-xmark tdm-bad"></i> Missing</span><b>${missing}</b></div>
        <div class="tdm-sum tdm-sum--sep"><span>Return Rate</span><b>${pigeonIds.length ? fmtPct(rate) : '—'}</b></div>
        <div class="tdm-sum"><span>Distance</span><b>${t.distanceKm || 0} km</b></div>
        <div class="tdm-sum"><span>Release Time</span><b>${fmtClock12(t.releaseAtMs)}</b></div>
      </div>`;

    const notesEl = document.getElementById('tdm-notes');
    const notes = (t.notes || '').trim();
    const arrivalNotes = (t.arrivalNotes || '').trim();
    if (notes || arrivalNotes) {
      notesEl.style.display = '';
      notesEl.innerHTML = '<div class="tdm-notes-title"><i class="fa-regular fa-note-sticky"></i> Notes</div>' +
        (notes ? '<p>' + notes + '</p>' : '') +
        (arrivalNotes ? '<p><span class="tdm-notes-tag">Arrival notes</span> ' + arrivalNotes + '</p>' : '');
    } else {
      notesEl.style.display = 'none';
      notesEl.innerHTML = '';
    }

    renderTrainingDetailResults();
  }

  function renderTrainingDetailResults() {
    const t = trainings[tdmTrainingId];
    if (!t) return;
    const arrivals = t.arrivals || {};
    const term = document.getElementById('tdm-search').value.trim().toLowerCase();
    let ids = (t.participatingPigeonIds || []).slice();
    // Returned pigeons first, in the order they came home; the rest keep the order they were entered.
    ids.sort((a, b) => {
      const aa = arrivals[a], bb = arrivals[b];
      if (aa && bb) return aa.arrivedAtMs - bb.arrivedAtMs;
      if (aa) return -1;
      if (bb) return 1;
      return 0;
    });
    const tbody = document.getElementById('tdm-tbody');
    const rows = ids.map((pid, i) => ({ pid, i: i + 1, doc: allPigeonDocs.find(d => d.id === pid) }))
      .filter(r => {
        if (!term) return true;
        const p = r.doc ? r.doc.p : null;
        return ((p && p.name) || '').toLowerCase().includes(term) || ((p && p.ringNumber) || '').toLowerCase().includes(term);
      });
    tbody.innerHTML = rows.length === 0
      ? '<tr class="ace-empty-row"><td colspan="7">' + (ids.length === 0 ? 'No pigeons were added to this training.' : 'No pigeons match your search.') + '</td></tr>'
      : rows.map(r => {
          const p = r.doc ? r.doc.p : null;
          const a = arrivals[r.pid];
          const st = tdmStatusOf(t, r.pid);
          const flight = a ? a.arrivedAtMs - t.releaseAtMs : null;
          return `
            <tr>
              <td class="tdm-c-num" data-label="#">${r.i}</td>
              <td class="tdm-c-avatar">${pigeonAvatarHtml(p)}</td>
              <td class="tdm-c-name"><b>${p ? p.name : 'Unknown'}</b><span class="ace-ring-m">${p && p.ringNumber ? p.ringNumber : '—'}</span></td>
              <td class="tdm-c-ring" data-label="Ring Number">${p && p.ringNumber ? p.ringNumber : '—'}</td>
              <td data-label="Arrival Time">${a ? new Date(a.arrivedAtMs).toTimeString().slice(0, 5) : '—'}</td>
              <td data-label="Flight Time">${flight !== null && flight >= 0 ? fmtFlightTime(flight) : '—'}</td>
              <td class="tdm-c-status"><span class="pgn-badge tdm-badge--${st}">${st === 'returned' ? 'Returned' : st === 'missing' ? 'Missing' : 'Pending'}</span></td>
            </tr>`;
        }).join('');
  }

  function openTrainingDetailModal(id) {
    if (!trainings[id]) return;
    tdmTrainingId = id;
    document.getElementById('tdm-search').value = '';
    renderTrainingDetailModal();
    document.getElementById('db-trndet-modal').classList.add('open');
  }
  (function wireTrainingDetailModal() {
    document.getElementById('tdm-close-btn').onclick = () => document.getElementById('db-trndet-modal').classList.remove('open');
    document.getElementById('tdm-search').addEventListener('input', renderTrainingDetailResults);
    document.getElementById('tdm-edit-btn').onclick = () => {
      const t = trainings[tdmTrainingId];
      document.getElementById('db-trndet-modal').classList.remove('open');
      if (t) openEditTrainingModal(tdmTrainingId, t);
    };
  })();

  const trnAceBtn = document.getElementById('trn-ace-btn');
  if (trnAceBtn) trnAceBtn.onclick = openAceModal;

